import fp from 'lodash/fp'
import { autorun } from 'mobx'
import { combine, withEffect, withCallbacks } from 'react-hooks-combine'

import FormComponent from './components'

export default combine(
  withCallbacks(
    {
      onInternalSubmit:
        (_state, { bypassInvalid, form, onSubmit }) =>
        (event) => {
          event.preventDefault()

          if (!fp.isFunction(onSubmit)) {
            return
          }

          form.setTouched(true)

          if ((!bypassInvalid && form.isInvalid) || form.submission) {
            return
          }

          const result = onSubmit(form.value, form)

          if (result && fp.isFunction(result.then)) {
            form.setSubmission(true)

            result.finally(() => {
              form.setSubmission(false)
            })
          }
        },
    },
    []
  ),
  withEffect((_state, { form, onValidationError }) => {
    if (onValidationError) {
      return autorun(() => {
        const { error } = form

        if (fp.isEmpty(error)) {
          return
        }

        onValidationError(error)
      })
    }
  }, [])
)(FormComponent)
